import axios from 'axios';

const instance = axios.create();

export default class File {
    download = (url) => {
        return instance.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/services/api/File.js